var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ve-chart',{ref:"ve-chart",attrs:{"loading":_vm.loading,"width":"100%","height":"100%","settings":_vm.settings,"colors":[_vm.color],"title":_vm.title,"series":_vm.series}})}
var staticRenderFns = []

export { render, staticRenderFns }